module.exports = __webpack_public_path__ + "img/couples-002.3779c11c.jpg";